import { PromptPreset } from '../types/heygen';

export const PROMPT_PRESETS: PromptPreset[] = [
  {
    key: 'professional',
    label: 'Profesional',
    prompt:
      'Minimize hand movement frequency. Use gestures only to emphasize key points, then return hands to a neutral resting position. Vary each gesture: mix single-hand raises, open palms, and brief pointing. Never repeat the same gesture consecutively.'
  },
  {
    key: 'dynamic',
    label: 'Dinámico',
    prompt:
      'Direct eye contact, soft confident smile, subtle head nods, natural blinking, warm and professional expression, gentle open-hand gestures, calm posture, approachable and trustworthy presence, minimal elegant body movement.'
  },
  {
    key: 'neutral',
    label: 'Neutro',
    prompt:
      'Neutral and composed expression, minimal gestures, steady and clear delivery, professional posture, consistent eye contact, calm and measured pace.'
  }
];
